/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Emailplaceholder1Inputs */

const zh_profile_emailplaceholder1 = /** @type {(inputs: Profile_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入邮箱`)
};

const en_profile_emailplaceholder1 = /** @type {(inputs: Profile_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email`)
};

const es_profile_emailplaceholder1 = /** @type {(inputs: Profile_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu correo electrónico`)
};

/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Profile_Emailplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_emailplaceholder1 = /** @type {((inputs?: Profile_Emailplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Emailplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_emailplaceholder1(inputs)
	if (locale === "en") return en_profile_emailplaceholder1(inputs)
	return es_profile_emailplaceholder1(inputs)
});
export { profile_emailplaceholder1 as "profile_emailPlaceholder" }